import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d4498b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menus" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "line" }, null, -1))
const _hoisted_3 = { class: "childrenMenus" }
const _hoisted_4 = ["onClick"]

import { ref, watch } from "vue";
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import router from '@/router/index'

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuItem',
  props: {
  name: String,
  isRouter: Boolean,
  index: String,
  activeIndex: String,
  menuRoute: String,
  children: Object
},
  emits: ['select', 'closeMenuOn'],
  setup(__props, { emit: emits }) {

const props = __props;

const store = useStore()
const isMobile = store.state.isMobile
const route = useRoute()
const curPath = ref('')
const isShowSubMenu = ref(false)

watch(() => route.path, (path) => {
  curPath.value = path
}, { immediate: true })


function onClickItem(path?: string) {
  if (path) {
    router.push(path)
    emits('closeMenuOn', false)
  } else {
    emits('select', props.index)
    if (isMobile) {
      isShowSubMenu.value = !isShowSubMenu.value
    }
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass([{ 'childrenContainer': !_unref(isMobile) }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['menuItemWrap', { 'menuItemPhone': _unref(isMobile) }, { 'menAactive': __props.menuRoute && (curPath.value === __props.index || __props.index === __props.activeIndex) }]),
      onClick: _cache[0] || (_cache[0] = () => onClickItem(__props.menuRoute))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(__props.name) + " ", 1),
        (!!__props.children && _unref(isMobile))
          ? (_openBlock(), _createElementBlock("em", {
              key: 0,
              class: _normalizeClass(['subArrow', { 'openArrow': isShowSubMenu.value }])
            }, null, 2))
          : _createCommentVNode("", true),
        _hoisted_2
      ])
    ], 2),
    (__props.children)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['childrenWrap', { 'showSubMenu': _unref(isMobile) && isShowSubMenu.value }])
        }, [
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.children, (childrenItem, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "childrenItem",
                key: index,
                onClick: () => onClickItem(childrenItem.route)
              }, _toDisplayString(childrenItem.name), 9, _hoisted_4))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})